/**
 * "Update required" (Console v2 §3.7, slice S6).
 * i18n/index.ts spreads this table; the slice adds its own keys here.
 */
import type { Dict } from '../core';

export const releasesV2En: Dict = {
  'upd.req.title': 'Update required',
  'upd.req.body':
    'This version of Neosocial ({version}) is too old to connect. Update to {min} or newer to keep going.',
  'upd.req.manual':
    'Download the installer and run it: your account and settings stay as they are.',
  'upd.req.download': 'Download the update',
};
